import { FC, useEffect, useRef } from 'react';
import { ChatMessage } from '../types';
import MessageItem from './MessageItem';

interface MessageListProps {
  messages: ChatMessage[];
  onNavigate?: () => void;
}

const MessageList: FC<MessageListProps> = ({ messages, onNavigate }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Filter out tool messages for display
  const displayMessages = messages.filter((msg) => msg.role !== 'tool');

  if (displayMessages.length === 0) {
    return null;
  }

  return (
    <div className="flex-1 overflow-y-auto px-4 py-4 bg-gray-50 dark:bg-slate-900">
      {displayMessages.map((message) => (
        <MessageItem key={message.id} message={message} onNavigate={onNavigate} />
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
